export default "__VITE_ASSET__CiybU9Pa__"